import { render } from "./SideBar.vue?vue&type=template&id=504aa3bc&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=504aa3bc&scoped=true&lang=css"
import "./SideBar.vue?vue&type=style&index=1&id=504aa3bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504aa3bc"]])

export default __exports__